document.addEventListener('DOMContentLoaded', function () {

  /* ---- rotate messages on a timer ------------------------------- */
  document.querySelectorAll('[data-promo-ticker]').forEach(function (wrapper) {
    var slides = wrapper.querySelectorAll('.promo-ticker__slide');
    if (!slides.length) return;

    var autoplay = wrapper.getAttribute('data-autoplay') === 'true';
    var interval = parseInt(wrapper.getAttribute('data-interval'), 10) || 5000;
    var ring = wrapper.querySelector('[data-promo-ring]');
    var toggleBtn = wrapper.querySelector('[data-promo-toggle]');
    var prevBtn = wrapper.querySelector('[data-promo-prev]');
    var nextBtn = wrapper.querySelector('[data-promo-next]');
    var index = 0;
    var timer = null;
    var manuallyPaused = false;

    wrapper.style.setProperty('--promo-interval', interval + 'ms');

    function resetRing() {
      if (!ring) return;
      /* Removing the class, forcing a reflow and re-adding the class in
         the SAME tick isn't reliable — some browsers coalesce it away and
         the animation never visibly restarts past the first slide. Doing
         the re-add on the next animation frame forces a real restart every
         time. */
      ring.classList.remove('is-animating');
      void ring.getBoundingClientRect();
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          ring.classList.add('is-animating');
        });
      });
    }

    function show(i) {
      slides.forEach(function (slide, slideIndex) {
        slide.classList.toggle('is-active', slideIndex === i);
      });
      resetRing();
    }

    function next() {
      index = (index + 1) % slides.length;
      show(index);
    }

    function start() {
      if (!autoplay || slides.length <= 1 || timer || manuallyPaused) return;
      timer = setInterval(next, interval);
    }

    function stop() {
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
    }

    function goTo(newIndex) {
      index = ((newIndex % slides.length) + slides.length) % slides.length;
      show(index);
      if (timer) {
        stop();
        start();
      }
    }

    show(index);
    start();

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        goTo(index - 1);
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        goTo(index + 1);
      });
    }

    if (toggleBtn) {
      toggleBtn.addEventListener('click', function () {
        manuallyPaused = !manuallyPaused;
        wrapper.classList.toggle('is-paused', manuallyPaused);
        toggleBtn.setAttribute('aria-pressed', manuallyPaused ? 'true' : 'false');
        var label = manuallyPaused ? 'Play offers' : 'Pause offers';
        toggleBtn.setAttribute('aria-label', label);
        toggleBtn.title = label;

        if (manuallyPaused) {
          stop();
        } else {
          start();
        }
      });
    }
  });

  /* ---- smooth-scroll to an in-page section for anchor links ----- */
  document.querySelectorAll('.promo-ticker__link[data-scroll-target]').forEach(function (link) {
    link.addEventListener('click', function (e) {
      var target = document.getElementById(link.getAttribute('data-scroll-target'));
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });

  /* ---- keep the ticker stuck directly under the sticky header --- */
  var headerEl = document.getElementById('jdh-root');
  if (!headerEl) return;

  function syncHeaderHeight() {
    document.documentElement.style.setProperty('--jdh-header-h', headerEl.offsetHeight + 'px');
  }

  syncHeaderHeight();
  window.addEventListener('resize', syncHeaderHeight);
  window.addEventListener('load', syncHeaderHeight);

  if (window.ResizeObserver) {
    new ResizeObserver(syncHeaderHeight).observe(headerEl);
  }
});
